import React, {FC} from "react";
import {Tooltip} from "antd";
import moment from "moment";
import {RefundStatusTag} from "../../../payments/Refunds/RefundsListColumns";
import {renderAmount} from "../../../../helpers/renderAmount";

const css = require("./MolliePaymentSection.less");

// Phase 23 / Plan 23-05 / BDSEC-07 — Inline-Refund-Liste unter Stats-Sektion
// einer paid-TimelineCard. Pro Refund: Status-Tag (reuse RefundStatusTag),
// Betrag, Datum, Grund (Tooltip-truncate).

export interface RefundListItemShape {
    id: string;
    mollieRefundId?: string | null;
    amount?: number | null;
    reason?: string | null;
    status: string;
    canceledAtProvider?: boolean | null;
    mollieCreatedAt?: string | Date | null;
    createDate?: string | Date | null;
}

export type RefundListProps = {
    refunds: ReadonlyArray<RefundListItemShape>;
};

function formatRefundDate(value: string | Date | null | undefined): string {
    if (!value) return "—";
    const m = moment(value);
    if (!m.isValid()) return "—";
    return m.format("L");
}

export const RefundList: FC<RefundListProps> = ({refunds}) => {
    if (!refunds || refunds.length === 0) {
        return null;
    }

    return (
        <div className={css.refundList} data-testid="refund-list">
            <div className={css.refundListTitle}>{"Erstattungen"}</div>
            {refunds.map((refund) => {
                const dateValue = refund.mollieCreatedAt || refund.createDate;
                return (
                    <div
                        key={refund.id}
                        className={css.refundRow}
                        data-testid={`refund-row-${refund.id}`}
                    >
                        <RefundStatusTag status={refund.status} canceledAtProvider={refund.canceledAtProvider} />
                        <span className={css.refundRowAmount}>
                            {refund.amount != null ? renderAmount({amount: refund.amount}) : "—"}
                        </span>
                        <Tooltip title={refund.reason || ""}>
                            <span className={css.refundRowReason}>{refund.reason || "—"}</span>
                        </Tooltip>
                        <span>{formatRefundDate(dateValue)}</span>
                    </div>
                );
            })}
        </div>
    );
};

export default RefundList;
